export class BaseBean{
    drawNumber: number;
    drawDate: string;
    totalWagerAmount: string;
    ticketReferenceNumber: string;
    terminal: string;
    buyDate: string;
    buyTime: string;
    username: string;
    wagerReference: string;
    sign: String;
    wagers: any = [];
}

export class VerificationGame extends BaseBean{
    //name = Melate;
    //class = tech.lotto.rs.core.gambling.ppap.melate.model.MelateSign;
    //wagerReference = "na";
    transactionType;
    wagerStatus;

    //wagers = []
    ticketReferenceNumber;
    //terminal;//terminal;
    //sign;
    //username;
    //*fullName;
    //buyDate;//
    //buyTime; //reqDateTime
    //totalWagerAmount: Number;
    //drawDate;
    //drawNumber;
    wagerSerialNumber;
    customer: Customer;
}




export class GameSign extends BaseBean{
    class: string = "tech.lotto.rs.core.gambling.ppap.melate.model.MelateSign";
    fullName: string;
    
        /*{
            //boardNumber: null,*
            //boardPrice: null,*
            //basePrice: null,*
            boardData = [];*
            revancha:boolean;*
            revanchita: boolean;
            /*revanchitaPrice: null,
            revanchaPrice: null,*
            revanchitaBasePrice: null,
            revanchaBasePrice: null,
            boardType: system6,*
            boardSize: 6*
        }
    ];*/
    name: string;

}


export class ProgolRevanchaWager{
  mainSeriesBoardData:ProgolRevanchaBoardData;
  secondarySeriesBoardData:ProgolRevanchaBoardData;
  progolRevancha:boolean = false;
}

export class ProgolRevanchaBoardData{
  boardData:string[] = [];
  boardPrice:number = 0;     
}

export class Customer {
    firstName: string;
    lastName: string;
    middleName: string;
    phoneNumber: string;
    address: Address;
    username: string;
}

export class Address{
    line1: string;
    line2: string;
    postalCode: string;
    city: string;
    state: string;
}

export const enum ResultTypes {
    success = 0,
    warning = 1,
    error = 2
}


// WEBPACK FOOTER //
// /jenkins/jenkins/workspace/apppronosticos_install_s3_dev/src/app/core/verify/melate-sign.ts